export interface PlayerMismatch {
  eventId: string;
  requestId: string | null;
  title: string;
  artist: string;
  playerName?: string;
  detectedAt: string;
  acknowledged: boolean;
  noAdvance: boolean;  // Bridge 1.10.0+ left the queue alone and the DJ chooses (ITER-173)
}

export interface QueueNextUp {
  eventId: string;
  requestId: string | null;
  updatedAt: string;
}

export function parsePlayerMismatch(raw: unknown): PlayerMismatch | null {
  if (!raw || typeof raw !== 'object') return null;
  const value = raw as Record<string, unknown>;
  if (typeof value.eventId !== 'string') return null;
  if (value.requestId !== null && typeof value.requestId !== 'string') return null;
  if (typeof value.title !== 'string' || typeof value.artist !== 'string') return null;
  if (typeof value.detectedAt !== 'string' || value.detectedAt === '') return null;
  if (typeof value.acknowledged !== 'boolean') return null;
  return {
    eventId: value.eventId,
    requestId: value.requestId as string | null,
    title: value.title,
    artist: value.artist,
    detectedAt: value.detectedAt,
    acknowledged: value.acknowledged,
    noAdvance: value.noAdvance === true,
    ...(typeof value.playerName === 'string' ? { playerName: value.playerName } : {}),
  };
}

export function shouldShowPlayerMismatch(
  mismatch: PlayerMismatch | null,
  eventId: string | undefined,
  nowPlayingId: string | null,
): mismatch is PlayerMismatch {
  if (!mismatch || !eventId) return false;
  return mismatch.eventId === eventId && mismatch.requestId === nowPlayingId;
}
